import React, { useRef, useState } from "react";
import phone from "../../img/phone.png";
import email from "../../img/email.png";
import adress from "../../img/adress.png";
import emailjs from "@emailjs/browser";

const Phone = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_aiupxek",
        "template_bbe88xb",
        formRef.current,
        "Vh-JN3U-59qPYhVZr"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="p">
      <div className="p-bg"></div>
      <div className="p-wrapper">
        <div className="p-left">
          <h1 className="p-title">
            contact me
            <i class="bi bi-telephone-outbound-fill m-3"></i>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              class="bi bi-telephone-outbound-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5z"
              />
            </svg>
          </h1>
          <div className="p-info"></div>
          <div className="p-info-item">
            <img src={phone} alt="" className="p-icon" />
            +91 8950606625
          </div>
          <div className="p-info-item">
            <img src={email} alt="" className="p-icon" />
            21622happysoni@gmail.com
          </div>
          <div className="p-info-item">
            <img src={adress} alt="" className="p-icon" />
            Delhi bypass,Rohtak
          </div>
        </div>
        <div className="p-right">
          <p className="p-desc">
            <b>what's your story?</b>Get in touch.Always freelancing if the
            right project comes along me.
          </p>
          <form ref={formRef} onSubmit={handleSubmit}>
            <input type="text" placeholder="Name" name="user-name" />
            <div>
              <input type="text" placeholder="Subject" name="user-subject" />
            </div>
            <input type="text" placeholder="Your_Email" name="user-email" />
            <textarea rows="5" placeholder="message" name="message" />
            <button>Submit</button>
            {done && "your mail is submitted (thank you...)"}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Phone;
